<input
    type="text"
    class="w-full h-full font-body-1 tracking-wide text-dat-grey-500 focus-visible:outline-none"
    [name]="randomName"
    [attr.data-testid]="id()"
    [attr.data-uiType]="'textBox'"
    [attr.data-styleTarget]="id() + '-input'"
    [attr.data-styleDisabled]="disabled()"
    [id]="id()"
    [placeholder]="placeholder()"
    [formControl]="inputControl"
/>
